import { Configuration, type Locale } from 'invictus-sdk-typescript'

import { type Pathname } from '@Types/navigation/navigation'
import { type RuntimeConfig } from '@Types/runtimeConfig'

declare const PUBLIC_RUNTIME_CONFIG: RuntimeConfig

export const getWidgetFrontendApiConfiguration = (widgetUrl?: string): Configuration => {
  const { backendApiPath } = PUBLIC_RUNTIME_CONFIG

  return new Configuration({
    basePath: widgetUrl ? `${widgetUrl}${backendApiPath}` : backendApiPath,
  })
}

export const computeURL = (pathname: Pathname, locale: Locale, widgetUrl?: string): string => {
  const { basePath } = PUBLIC_RUNTIME_CONFIG
  const frontAppUrl = widgetUrl ? `${widgetUrl}${basePath}` : basePath

  return `${frontAppUrl}/${locale}${pathname}`
}
